import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

// Super simplified component that will never cause infinite loops
const PaymentFailed = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderNumber = searchParams.get("orderNumber");

  // No useEffect, no state updates that could cause loops
  return (
    <div className="payment-failed container mx-auto py-16 text-center">
      <div className="error-icon text-6xl mb-6">❌</div>
      <h2 className="text-3xl font-semibold mb-4">
        Plata nu a putut fi procesată
      </h2>
      <p className="text-gray-600 mb-8 max-w-xl mx-auto">
        Din păcate, tranzacția dvs. nu a putut fi finalizată. Acest lucru poate
        fi cauzat de fonduri insuficiente, eroare de card sau alte probleme cu
        metoda de plată.
      </p>

      <div className="flex flex-col sm:flex-row justify-center gap-4">
        <button
          onClick={() => navigate("/checkout")}
          className="px-4 py-2 bg-primary text-white rounded hover:bg-primary-dark"
        >
          Încearcă o altă metodă de plată
        </button>
        <button
          onClick={() => navigate("/")}
          className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-100"
        >
          Pagina principală
        </button>
      </div>

      {orderNumber && (
        <p className="mt-4 text-sm text-gray-400">Comanda: {orderNumber}</p>
      )}
    </div>
  );
};

export default PaymentFailed;
